import { Tab, Tabs } from '@mui/material';

interface TabInfo {
  label: string;
  value: string;
}

interface Props {
  tabs: TabInfo[];
  tab: string;
  handleTabChange: (_event: React.SyntheticEvent, newTab: string) => void;
  width?: string;
}

const TabsBarForTools = ({
  tabs,
  tab,
  handleTabChange,
  width
}: Props): JSX.Element => {
  return (
    <Tabs
      value={tab}
      onChange={handleTabChange}
      textColor="secondary"
      indicatorColor="secondary"
      variant="scrollable"
      scrollButtons="auto"
      sx={{
        '.MuiTabs-root': {
          height: '50px',
          backgroundColor: 'red'
        },
        '.MuiTabs-flexContainer': {
          height: '50px'
        }
      }}
    >
      {tabs.map((tabInfo, index) => (
        <Tab
          key={index}
          label={tabInfo.label}
          value={tabInfo.label}
          sx={{
            display: 'flex',
            fontSize: '14px',
            flexWrap: 'wrap',
            fontWeight: 500,
            color: '#44474E',
            textTransform: 'capitalize',
            letterSpacing: 0.1,
            minWidth: width ?? 'auto',
            flexGrow: 1
          }}
        />
      ))}
    </Tabs>
  );
};

export default TabsBarForTools;
